import React, { useContext } from 'react';
import { PagerContext } from './PagerProvider';

interface IPageProps {
  index: number;
}

const Page: React.FC<IPageProps> = ({ children, index }) => {
  const context = useContext(PagerContext);
  const isActivePage = context?.currentPage === index;

  return isActivePage ? (
    <div key={index} className='h-100'>
      {children}
    </div>
  ) : null;
};

export default Page;
